import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";
import { useEffect } from "react";

//Components
import { Modal, ModalBody, ModalFooter, Button } from "@gpstrackit/react-controls";
import { NotificationManager } from 'Components/Notifications';

//Actions
import {
    clearRedux,
    eventDeleteRequest,
} from 'Redux/actions';

const DeleteEvent = (props) => {
    const { tableRef } = props;
    const { messages } = useIntl();
    const dispatch = useDispatch();

    const {
        openModal,
        loading,
        event,
        result,
    } = useSelector(state => state.deleteEventRedux);

    const handleDelete = () => {
        dispatch(eventDeleteRequest(event?.id))
    }

    const closeModal = () => {
        dispatch(clearRedux("EVENT_DELETE"))
    }

    useEffect(() => {
        if(result){
            NotificationManager.success(
                messages['event_delete_success_message'],
                messages['event_delete_title'],
                3000
            );
            tableRef && tableRef?.current?.getData();
            closeModal()
            dispatch(clearRedux("EVENT_DELETE", { result: null }))
        }
    }, [result])

    return (
        <Modal
            open={openModal}
            title={`${messages['event_delete_title']} (${event?.name})`}
            handleClose={() => closeModal()}
            position="right"
            loading={loading}
            size="small"
        >
            <ModalBody>
                <div style={{ padding: '0 10px', height: 600 }}>
                    {messages['event_delete_message']}
                </div>
            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn btn-cancel"
                    onClick={() => closeModal()}
                >
                    {messages['common_cancel']}
                </Button>
                <Button
                    className="btn-dark-blue"
                    onClick={handleDelete}
                >
                    {messages['delete']}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default DeleteEvent;


